"use client";

import React from "react";

export function Header131() {
  return (
    /* bg-wood-brown = tvoje hnědá, text-white = bílý text */
    <section className="bg-wood-brown text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto">
        
        {/* Horní část: Nadpis a Text (zůstává stejná) */}
        <div className="mb-12 grid grid-cols-1 items-start gap-x-12 gap-y-8 md:mb-18 md:grid-cols-2 lg:mb-20 lg:gap-x-20">
          <h1 className="text-[48px] font-bold font-serif leading-[1.1] md:text-[54px] lg:text-[56px]">
            Práce našich rukou
          </h1>
          
          <div className="flex flex-col justify-center h-full">
            <p className="text-lg md:text-xl opacity-90 leading-[1.6]">
            Zavolejte nám nebo napište. Probereme společné možnosti a připravíme pro Vás kalkulaci a návrh postupu prací.
            </p>
            
            <div className="mt-8 flex flex-wrap gap-4">
              {/* Tlačítko Zavolat - Bílá pilulka s černým textem pro maximální viditelnost */}
              <a 
                href="tel:+420723856780"
                className="px-8 py-3 bg-white text-wood-brown font-bold rounded-full hover:bg-opacity-90 transition-all text-center min-w-[140px]"
              >
                VOLAT
              </a>
              
              {/* Tlačítko Kontakt - Bílá linka, vede na mail */}
              <a 
                href="mailto:jiri@tesarstvi-sindelar.cz"
                className="px-8 py-3 border border-white text-white font-bold rounded-full hover:bg-white/10 transition-all text-center min-w-[140px]"
              >
                jiri@tesarstvi-sindelar.cz
              </a>
            </div>
          </div>
        </div>

        {/* Spodní část: JEDEN Obrázek (Zjednodušeno) */}
        {/* Přidal jsem mt-12..., aby to dýchalo pod textem */}
        <div className="w-full overflow-hidden rounded-xl mt-12 md:mt-18 lg:mt-20">
          <img
            src="img/koncontainer.png" // Nechal jsem hlavní velkou fotku
            className="aspect-[3/2] w-full object-cover transition-transform duration-700 hover:scale-105"
            alt="Realizace tesařství"
          />
        </div>

      </div>
    </section>
  );
}